import "./LocaleDropdown.scss";
import { useState, useRef } from "react";
import { LanguageAvailable } from "constants/LanguageAvailable";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import i18next from "i18next";
import { useOnClickOutside } from "hooks/useOnClickOutside";
import { useTranslation } from "react-i18next";

const LocaleDropdown = () => {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const listRef = useRef<HTMLDivElement>(null);
  useOnClickOutside(listRef, () => {
    setOpen(false);
  });
  const handleChange = (ln: string) => {
    setOpen(false);
    i18next.changeLanguage(ln);
  };
  return (
    <div className="locale-dropdown" ref={listRef}>
      <div className="current-language" onClick={() => setOpen(!open)}>
        {LanguageAvailable.find(
          (ln) => ln.code === i18n.language
        )?.code || 'en'}
        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      </div>
      {open && (
        <div className="languages-list">
          <div className="languages">
            {LanguageAvailable.map((ln) => (
              <div
                key={ln.code}
                className={
                  i18n.language == ln.code
                    ? "selected-language language"
                    : "language"
                }
                onClick={() => handleChange(ln.code)}
              >
                {ln.title}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default LocaleDropdown;
